export const collaborationFeatureName = 'collaboration';

export default {
  collaborationFeatureName,
};
